import React from "react";
import logoBlue from "../../assets/dear-logo-blue.png";
import "./styles/LegalNotice.css";

function LegalNotice() {
  return (
    <div>
      <img className="logo-legal" src={logoBlue} alt="logo Dear bleu" />
      <h1 className="legal-title">Mentions Légales</h1>
      <p>
        Conformément aux dispositions des articles 6-111 et 19 de la Loi n°
        2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique,
        dite L.C.E.N., nous portons à la connaissance des utilisateurs et
        visiteurs du site : dear-application.fr les informations suivantes :
      </p>
      <div className="titlelegalnotice">
        <h2>ÉDITEUR </h2>
      </div>
      <p>
        Le site dear-application.fr est la propriété exclusive de xxxx DEAR, qui
        l'édite. DEAR xxx au capital de xxxx€ Tél : 07 71 01 11 29 Adresse : 02
        RUE PREMARTINE 72000 LE MANS Immatriculée au Registre du Commerce et des
        Sociétés de RCXXXXXX sous le numéro XXXXXXX Numéro TVA
        intracommunautaire : XXXXXXX Adresse de courrier électronique :
        dear.officiel@gmail.com Directeur de la publication : DEAR Contactez le
        responsable de la publication : dear.officiel@gmail.com HÉBERGEMENT : Le
        site est hébergé par XXXXX
      </p>
      <div className="titlelegalnotice">
        <h2>DESCRIPTION DES SERVICES FOURNIS </h2>
      </div>
      <p>
        L'application DEAR a pour objet de fournir une information concernant
        l'ensemble des activités de la société. Le propriétaire de l'application
        s'efforce de fournir sur l'application des informations aussi précises
        que possible. Toutefois, il ne pourra être tenu responsable des
        omissions, des inexactitudes et des carences dans la mise à jour,
        qu'elles soient de son fait ou du fait des tiers partenaires qui lui
        fournissent ces informations. Toutes les informations proposées sur
        l'application sont données à titre indicatif, sont non exhaustives, et
        sont susceptibles d'évoluer. Elles sont données sous réserve de
        modifications ayant été apportées depuis leur mise en ligne.
      </p>
      <div className="titlelegalnotice">
        <h2>
          CONDITIONS GÉNÉRALES D'UTILISATION DE L'APPLICATION ET DES SERVICES
          PROPOSÉS
        </h2>
      </div>
      <p>
        L'utilisation de l'application Dear implique l'acceptation pleine et
        entière des conditions générales d'utilisation disponibles sur
        dear-application-CGU.fr ou directement sur l'application DEAR. Ces
        conditions d'utilisation sont susceptibles d'être modifiées ou
        complétées à tout moment, les utilisateurs de l'application Dear
        sontdonc invités à les consulter de manière régulière. Cette application
        est normalement accessible à tout moment aux utilisateurs. Une
        interruption pour raison de maintenance technique ou mise à jour peut
        être toutefois décidée par DEAR, qui s'efforcera alors de communiquer
        préalablement aux utilisateurs les dates et heures de l'intervention.
        L'application DEAR est mise à jour régulièrement par notre prestataire
        de développement mobile xxxx. De la même façon, les mentions légales
        peuvent êtremodifiées à tout moment: elles s'imposent néanmoins à
        l'utilisateur qui est invité à s'yréférer le plus souvent possible afin
        d'en prendre connaissance.
      </p>
      <div className="titlelegalnotice">
        <h2>PROPRIÉTÉ INTELLECTUELLE ET CONTREFAÇONS</h2>
      </div>
      <p>
        Le propriétaire de l'application DEAR est propriétaire des droits de
        propriété intellectuelle ou détient les droits d'usage sur tous les
        éléments accessibles sur l'application, notamment les textes, images,
        graphismes, logo, icônes, vidéos, posts... Toute reproduction,
        représentation, modification, publication, adaptation totale ou
        partielle des éléments du site, quel que soit le moyen ou le procédé
        utilisé, est interdite, sauf autorisation écrite préalable à l'email :
        dear.officiel@gmail.com. Toute exploitation non autorisée de
        l'application ou de l'un quelconque de ces éléments qu'il contient sera
        considérée comme constitutive d'une contrefaçon et poursuivie
        conformément aux dispositions des articles L.335-2 et suivants du Code
        de Propriété Intellectuelle.
      </p>
      <div className="titlelegalnotice">
        <h2>LIENS HYPERTEXTES ET COOKIES</h2>
      </div>
      <p>
        L'application DEAR contient un certain nombre de liens hypertextes vers
        d'autres sites (partenaires, informations ...) mis en place avec
        l'autorisation du propriétaire de l'application. Cependant, le
        propriétaire de l'application n'a pas la possibilité de vérifier le
        contenu des sites ainsi visités et décline donc toute responsabilité de
        ce fait quant aux risques éventuels de contenus illicites. L'utilisateur
        est informé que lors de ses visites sur la landing page de DEAR, des
        cookies sont susceptibles de s'installer automatiquement sur son
        ordinateur. Un cookie est un fichier de petite taille, qui ne permet pas
        l'identification de l'utilisateur, mais qui enregistre des informations
        relatives à la navigation d'un ordinateur sur un site. De plus, les
        informations utilisateurs.trices de l'application seront enregistrées
        dans une base de données afin de réaliser de la publicité ciblée. Les
        données ainsi obtenues visent à faciliter la navigation ultérieure sur
        le site, et ont également vocation à permettre diverses mesures de
        fréquentation. Le paramétrage du logiciel de navigation permet
        d'informer de la présence de cookie et éventuellement, de refuser de la
        manière décrite à l'adresse suivante : www.cnil.fr. Aujourd'hui,
        l'utilisateur peut refuser l'installation des cookies directement via le
        site ouapplication en question.{" "}
      </p>
      <div className="titlelegalnotice">
        <h2>Limitations de responsabilité.</h2>
      </div>
      <p>
        Dear ne pourra être tenue responsable des dommages directs et indirects
        causés au matériel de l'utilisateur, lors de l'accès à sa landing page
        ou son application, et résultant soit de l'utilisation d'un matériel ne
        répondant pas aux conditions, soit del'apparition d'un bug ou d'une
        incompatibilité. Des espaces interactifs (dans le feed d'actualité et
        l'espace contact de l'application) sont à la disposition des
        utilisateurs.Dear se réserve le droit de supprimer, sans mise en demeure
        préalable, tout contenu déposé dans cet espace qui contreviendrait à la
        charte de confiance de la marque. Le cas échéant, Dear se réserve
        également la possibilité de mettre en cause la responsabilité civile
        et/ou pénale de l'utilisateur, notamment en cas de message à caractère
        raciste, injurieux, diffamant, ou pornographique, quel que soit le
        support utilisé (texte, photographie...).
      </p>
      <div className="titlelegalnotice">
        <h2>
          PROTECTION DES BIENS ET DES PERSONNES - GESTION DES DONNÉES
          PERSONNELLES
        </h2>
      </div>
      <p className="lastparagraphlegalnotice">
        En France, les données personnelles sont notamment protégées par la loi
        n° 78-87 du 6 janvier 1978, la loi no 2004-801 du 6 août 2004, l'article
        L. 226-13 du Code pénal et la Directive Européenne du 24 octobre 1995.
        référence RGPD Sur la landing page dear-application.fr, le propriétaire
        du site ne collecte des informations personnelles relatives à
        l'utilisateur que pour le besoin de certains services proposés par la
        landing page dear-application.fr. L'utilisateur fournit ces informations
        en toute connaissance de cause, notamment lorsqu'il procède par lui même
        à leur saisie. Il est alors précisé à l'utilisateur de la landing page
        dear-application.fr l'obligation ou non de fournir ces informations.
        Conformément aux dispositions des articles 38 et suivants de la loi
        78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux
        libertés, tout utilisateur dispose d'un droit d'accès, de rectification,
        de suppression et d'opposition aux données personnelles le concernant.
        Pour l'exercer, adressez votre demande à dear.officiel@gmail.com par
        email : email du webmaster ou en effectuant sa demande écrite et signée,
        accompagnée d'une copie du titre d'identité avec signature du titulaire
        de la pièce, en précisant l'adresse à laquelle laréponse doit être
        envoyée. Aucune information personnelle de l'utilisateur de la landing
        page dear-application.fr n'est publiée à l'insu de l'utilisateur,
        échangée, transférée, cédée ou vendue sur unsupport quelconque à des
        tiers. Le site xxxx est en conformité avec le RGPD. Les bases de données
        sont protégées par les dispositions de la loi du ler juillet 1998
        transposant la directive 96/9 du 11 mars 1996 relative à la protection
        juridique desbases de données.
      </p>
    </div>
  );
}

export default LegalNotice;
